module.exports = __webpack_public_path__ + "img/jd_student_small.ae950735.png";